var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content',[(_vm.showSpan)?_c('span',[_vm._v("\n    "+_vm._s(_vm.departs && _vm.departs.length > 0
        ? [].concat( _vm.departs )
            .map(function (r) {
              return _vm.$getDepartTree(r).departName
            })
            .join(',')
        : '')+"\n  ")]):_c('a-tree-select',{staticClass:"select-depart-tree",attrs:{"treeDefaultExpandAll":"","allowClear":_vm.allowClear,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"treeCheckable":_vm.treeCheckable,"treeCheckStrictly":_vm.treeCheckStrictly,"treeData":_vm.treeData,"showSearch":_vm.showSearch},model:{value:(_vm.departs),callback:function ($$v) {_vm.departs=$$v},expression:"departs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }